module.exports = __webpack_public_path__ + "img/hr-storage-tank-shadow.975ab7b7.png";